/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import ManagementReportGeneratorPage from './ManagementReportGeneratorPage'
import ManagementReportListPage from './ManagementReportListPage'
import ManagementReportPage from './ManagementReportPage'

export const managementReportRoutes: RouteObject[] = [
  {
    index: true,
    element: <ManagementReportListPage />
  },
  {
    path: 'generate',
    element: <ManagementReportGeneratorPage />
  },
  {
    path: 'view',
    element: <ManagementReportPage />
  }
]
